// extracted by mini-css-extract-plugin
module.exports = {"Register":"Register_Register__1zRdK","RegisterParent":"Register_RegisterParent__IAWjn"};